import React from 'react';
import { TIME_LOG_STATE } from '../../constants/timeLog';
import './WorkClockControls.scss';

function WorkClockControls({
  clockState,
  actionLoading,
  onClockIn,
  onPause,
  onResume,
  onClockOut,
  variant = 'default',
}) {
  const isOff = clockState === TIME_LOG_STATE.OFF;
  const isActive = clockState === TIME_LOG_STATE.ACTIVE;
  const isPaused = clockState === TIME_LOG_STATE.PAUSED;

  return (
    <div className={`work-clock-controls work-clock-controls--${variant}`} role="group" aria-label="Work clock actions">
      <button
        type="button"
        className={`work-clock-controls__btn work-clock-controls__btn--in${isOff ? ' is-current' : ''}`}
        disabled={!isOff || actionLoading}
        onClick={onClockIn}
      >
        Clock In
      </button>
      <button
        type="button"
        className={`work-clock-controls__btn work-clock-controls__btn--pause${isPaused ? ' is-current' : ''}${isActive ? ' is-running' : ''}`}
        disabled={(!isActive && !isPaused) || actionLoading}
        onClick={isPaused ? onResume : onPause}
      >
        {isPaused ? 'Resume' : 'Pause'}
      </button>
      <button
        type="button"
        className={`work-clock-controls__btn work-clock-controls__btn--out${isOff ? '' : ' is-available'}`}
        disabled={isOff || actionLoading}
        onClick={onClockOut}
      >
        Clock Out
      </button>
    </div>
  );
}

export default WorkClockControls;
